import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	spotlightTitle: {
		id: 'servicedesk-itsm-first-session-flow.your-work-tour.spotlight-tour.itsm-sample-project.spotlight-title',
		defaultMessage: 'Here’s your training ground',
		description: `Title text
            - for a spotlight that highlights the "ITSM Sample Space" card
            - part of an onboarding tour in the 'Your Work' page, for 1st time users of JSM`,
	},
	spotlightBody: {
		id: 'servicedesk-itsm-first-session-flow.your-work-tour.spotlight-tour.itsm-sample-project.spotlight-body',
		defaultMessage:
			'Use this sample space to try out different settings and features with sample data before using them in your live projects.',
		description: `Body text
            - for a spotlight that highlights the "ITSM Sample Space" card
            - part of an onboarding tour in the 'Your Work' page, for 1st time users of JSM`,
	},
	spotlightOkButton: {
		id: 'servicedesk-itsm-first-session-flow.your-work-tour.spotlight-tour.itsm-sample-project.spotlight-ok-button',
		defaultMessage: 'Ok',
		description: `Button text that will finish the spotlight tour
            - for a spotlight that highlights the "ITSM Sample Space" card
            - part of an onboarding tour in the 'Your Work' page, for 1st time users of JSM`,
	},
	spotlightBackButton: {
		id: 'servicedesk-itsm-first-session-flow.your-work-tour.spotlight-tour.itsm-sample-project.spotlight-back-button',
		defaultMessage: 'Back',
		description: `Button text that will go to the previous spotlight in the tour
            - for a spotlight that highlights the "ITSM Sample Space" card
            - part of an onboarding tour in the 'Your Work' page, for 1st time users of JSM`,
	},
});
